import React from 'react';
import PropTypes from 'prop-types';

export const BanknoteIcon = ({
  color = 'currentColor',
  strokeWidth = 2,
  ...props
}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="20"
      height="12"
      x="2"
      y="6"
      rx="2"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <circle cx="12" cy="12" r="2" stroke={color} strokeWidth={strokeWidth} />
    <path
      d="M6 12h.01M18 12h.01"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BanknoteIcon.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.number
};

export const BackIcon = ({ strokeWidth = 2, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 18L9 12L15 6"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BackIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number
};

export const WalletIcon = ({ color = 'currentColor', className }) => {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Wallet Body */}
      <rect
        x="3"
        y="6"
        width="18"
        height="13"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />

      {/* Wallet Flap */}
      <path
        d="M5 6V4.8C5 3.8 5.8 3 6.8 3H18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Card */}
      <line
        x1="14"
        y1="12"
        x2="18"
        y2="12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ChevronRightIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 6L15 12L9 18"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// export const ChevronRightIcon = ({ strokeWidth = 2, ...props }) => (
//   <svg
//     width="1em"
//     height="1em"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     <path
//       d="M9 6L15 12L9 18"
//       stroke="currentColor"
//       strokeWidth={strokeWidth}
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// ChevronRightIcon.propTypes = {
//   width: PropTypes.number,
//   height: PropTypes.number,
//   color: PropTypes.string,
//   strokeWidth: PropTypes.number
// };

// export const WalletIcon = ({
//   width = '1em',
//   height = '1em',
//   strokeWidth = 2,
//   ...props
// }) => (
//   <svg
//     width={width}
//     height={height}
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     <rect
//       x="3"
//       y="6"
//       width="18"
//       height="13"
//       rx="2"
//       stroke="currentColor"
//       strokeWidth={strokeWidth}
//     />

//     <path
//       d="M5 6V4.5C5 3.7 5.7 3 6.5 3H18"
//       stroke="currentColor"
//       strokeWidth={strokeWidth}
//       strokeLinecap="round"
//     />

//     <line
//       x1="14"
//       y1="12"
//       x2="18"
//       y2="12"
//       stroke="currentColor"
//       strokeWidth={strokeWidth}
//       strokeLinecap="round"
//     />
//   </svg>
// );

// WalletIcon.propTypes = {
//   width: PropTypes.number,
//   height: PropTypes.number,
//   color: PropTypes.string,
//   strokeWidth: PropTypes.number
// };

export const ArrowUpIcon = ({
  circleColor = '#E6E6E6',
  arrowColor = '#6B7280',
  ...props
}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill={circleColor} />

    <path
      d="M16 21V11"
      stroke={arrowColor}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M12 15L16 11L20 15"
      stroke={arrowColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowUpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  circleColor: PropTypes.string,
  arrowColor: PropTypes.string
};

export const ArrowDownIcon = ({
  circleColor = '#D8F3DC',
  arrowColor = '#00A651',
  ...props
}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill={circleColor} />

    <path
      d="M16 11V21"
      stroke={arrowColor}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M20 17L16 21L12 17"
      stroke={arrowColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowDownIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  circleColor: PropTypes.string,
  arrowColor: PropTypes.string
};
